import React, { Component } from "react";
import "./Skills.css";
import { skills, techSkills } from "../../portfolio";
import { Fade } from "react-reveal";

class SkillSection extends Component {
  categorizeSkills = () => {
    const pmSkills = skills.data[0].softwareSkills;
    const techSkillsList = techSkills.data[0].softwareSkills;

    const categories = {
      // Top Row - Technical Categories
      backend: {
        title: "Backend Development",
        icon: "⚙️",
        color: "#FF6B35",
        gradient: "linear-gradient(135deg, #FF6B35, #F7931E)",
        skills: [],
        order: 1,
      },
      frontend: {
        title: "Frontend Development",
        icon: "💻",
        color: "#61DAFB",
        gradient: "linear-gradient(135deg, #61DAFB, #21D4FD)",
        skills: [],
        order: 2,
      },
      devops: {
        title: "DevOps & Cloud",
        icon: "☁️",
        color: "#FF9900",
        gradient: "linear-gradient(135deg, #FF9900, #FFB347)",
        skills: [],
        order: 3,
      },
      // Bottom Row - Product Management Categories
      strategy: {
        title: "Product Strategy",
        icon: "🎯",
        color: "#667eea",
        gradient: "linear-gradient(135deg, #667eea, #764ba2)",
        skills: [],
        order: 4,
      },
      ai: {
        title: "Artificial Intelligence",
        icon: "🤖",
        color: "#10B981",
        gradient: "linear-gradient(135deg, #10B981, #059669)",
        skills: [],
        order: 5,
      },
      tools: {
        title: "Others",
        icon: "🛠️",
        color: "#f093fb",
        gradient: "linear-gradient(135deg, #f093fb, #f5576c)",
        skills: [],
        order: 6,
      },
    };

    // PM-focused categorization logic
    pmSkills.forEach((skill) => {
      const skillName = skill.skillName.toLowerCase();

      if (
        skillName.includes("strategy") ||
        skillName.includes("roadmap") ||
        skillName.includes("stakeholder") ||
        skillName.includes("user") ||
        skillName.includes("research") ||
        skillName.includes("interview") ||
        skillName.includes("persona")
      ) {
        // Combine strategy and research into Product Strategy
        categories.strategy.skills.push(skill);
      } else {
        // Product tools (Figma, Notion, etc.)
        categories.tools.skills.push(skill);
      }
    });

    // Tech skills categorization
    techSkillsList.forEach((skill) => {
      const skillName = skill.skillName.toLowerCase();

      if (
        skillName.includes("react") ||
        skillName.includes("html") ||
        skillName.includes("css")
      ) {
        categories.frontend.skills.push(skill);
      } else if (
        skillName === "aws" ||
        skillName.includes("docker") ||
        skillName.includes("kubernetes") ||
        skillName.includes("terraform") ||
        skillName.includes("helm") ||
        skillName.includes("spinnaker")
      ) {
        categories.devops.skills.push(skill);
      } else {
        // Backend skills
        categories.backend.skills.push(skill);
      }
    });

    // Add AI skills
    const aiSkills = [
      {
        skillName: "LLM",
        fontAwesomeClassname: "fa-solid:brain",
        style: { color: "#10B981" },
      },
      {
        skillName: "Cursor",
        fontAwesomeClassname: "fa-solid:code",
        style: { color: "#6366F1" },
      },
      {
        skillName: "Lovable",
        fontAwesomeClassname: "fa-solid:magic",
        style: { color: "#8B5CF6" },
      },
      {
        skillName: "ChatGPT",
        fontAwesomeClassname: "fa-solid:comments",
        style: { color: "#10A37F" },
      },
      {
        skillName: "Claude",
        fontAwesomeClassname: "fa-solid:robot",
        style: { color: "#D97706" },
      },
      {
        skillName: "GitHub Copilot",
        fontAwesomeClassname: "fa-brands:github",
        style: { color: "#181717" },
      },
    ];

    aiSkills.forEach((skill) => {
      categories.ai.skills.push(skill);
    });

    return categories;
  };

  render() {
    const theme = this.props.theme;
    const skillCategories = this.categorizeSkills();

    // Sort categories by order: backend(1), frontend(2), devops(3), strategy(4), analytics(5), tools(6)
    const sortedCategories = Object.entries(skillCategories).sort(
      ([, a], [, b]) => a.order - b.order
    );

    return (
      <div className="unified-skills-container">
        <div className="skills-categories-grid-6">
          {sortedCategories.map(([key, category], index) => (
            <Fade up duration={1000} delay={index * 100} key={key}>
              <div className="modern-skill-category">
                <div className="category-header-modern">
                  <div
                    className="category-icon-modern"
                    style={{ background: category.gradient }}
                  >
                    <span className="category-emoji">{category.icon}</span>
                  </div>
                  <div className="category-info-modern">
                    <h3
                      className="category-title-modern"
                      style={{ color: theme.text }}
                    >
                      {category.title}
                    </h3>
                    <p
                      className="category-description-modern"
                      style={{ color: theme.secondaryText }}
                    >
                      {this.getCategoryDescription(key)}
                    </p>
                  </div>
                </div>

                <div className="skills-showcase">
                  {category.skills.map((skill, skillIndex) => (
                    <div
                      key={skillIndex}
                      className="modern-skill-item"
                      style={{
                        "--skill-color": category.color,
                        "--skill-gradient": category.gradient,
                        animationDelay: `${skillIndex * 0.1}s`,
                      }}
                      title={skill.skillName}
                    >
                      <div className="skill-logo-container">
                        <img
                          src={this.getSkillLogo(skill.skillName)}
                          alt={skill.skillName}
                          className="modern-skill-logo"
                          onError={(e) => {
                            e.target.src =
                              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iNCIgZmlsbD0iIzMzMzMzMyIvPgo8dGV4dCB4PSIxNCIgeT0iMTgiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxMiIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPkM8L3RleHQ+Cjwvc3ZnPgo=";
                          }}
                        />
                      </div>
                      <span className="modern-skill-name">
                        {skill.skillName}
                      </span>
                      <div
                        className="skill-glow"
                        style={{ background: category.gradient }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    );
  }

  getCategoryDescription = (categoryKey) => {
    const descriptions = {
      strategy: "Defining product vision, roadmaps, and strategic direction",
      ai:
        "Leveraging AI tools and LLMs for enhanced productivity and innovation",
      tools: "Productivity tools for product management workflows",
      backend:
        "Core expertise in building robust, scalable server architectures",
      frontend: "Crafting beautiful, responsive user interfaces",
      devops: "Deploying and managing cloud infrastructure",
    };
    return descriptions[categoryKey] || "Expertise in this domain";
  };

  getSkillLogo = (skillName) => {
    const logoMap = {
      // Product Strategy
      "Product Strategy":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/chartline.svg",
      "Roadmap Planning":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/route.svg",
      "Stakeholder Management":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/users.svg",
      "User Research":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/usercheck.svg",
      "User Interviews":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/comments.svg",
      "Persona Development":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/userfriends.svg",

      // AI Tools
      LLM:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/openai.svg",
      Cursor:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236366F1'%3E%3Cpath d='M13.64 21.97c-.85.24-1.72.39-2.64.39-5.52 0-10-4.48-10-10S5.48 2.36 11 2.36c.85 0 1.68.15 2.45.42l-1.27 1.27c-.5-.08-1.02-.12-1.58-.12-4.41 0-8 3.59-8 8s3.59 8 8 8c.66 0 1.28-.08 1.87-.22l1.32 1.33zm5.5-3.75l1.27-1.27c.37.74.59 1.56.59 2.45 0 2.2-1.35 4.05-3.22 4.82l1.27 1.27C20.88 22.36 22 20.43 22 18.36c0-1.04-.28-2.01-.77-2.85l1.41-1.41zm-2.54 2.54l-1.41 1.41c-.84-.49-1.81-.77-2.85-.77-1.07 0-2.08.25-2.98.68l1.27 1.27c.59-.14 1.21-.22 1.87-.22 1.18 0 2.28.31 3.22.82z'/%3E%3C/svg%3E",
      Lovable:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%238B5CF6'%3E%3Cpath d='M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'/%3E%3C/svg%3E",
      ChatGPT:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/openai.svg",
      Claude:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/anthropic.svg",
      "GitHub Copilot":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg",

      // Product Tools
      "Agile/Scrum":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/scrum.svg",
      JIRA:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/jira.svg",
      Confluence:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/confluence.svg",
      Figma:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/figma.svg",
      Notion:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/notion.svg",

      // Technical Skills
      Java:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/java.svg",
      "Spring Boot":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/spring.svg",
      NodeJS:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/nodedotjs.svg",
      MySQL:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mysql.svg",
      MongoDB:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mongodb.svg",
      Redis:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/redis.svg",
      Kafka:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/apachekafka.svg",
      ReactJS:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/react.svg",
      HTML5:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/html5.svg",
      CSS3:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/css3.svg",
      "C++":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/cplusplus.svg",
      AWS:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/amazonaws.svg",
      Docker:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/docker.svg",
      Kubernetes:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/kubernetes.svg",
      Terraform:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/terraform.svg",
      "Helm Chart":
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/helm.svg",
      Spinnaker:
        "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/spinnaker.svg",
    };

    // Fallback for skills without specific logos
    return (
      logoMap[skillName] ||
      "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/producthunt.svg"
    );
  };
}

export default SkillSection;
